import React from 'react';

type BlogSlug = {
  slug: string;
  locale: string;
};

type CanonicalSEOProps = {
  slugs: BlogSlug[];
  locale: string | undefined; // Array der Slugs mit Lokalisierungen
  /** URL segment the section lives under, e.g. 'news' or 'magazine'. Defaults to 'news'. */
  basePath?: string;
  /** Whether to emit the RSS feed alternate link (only sections that have a feed). Defaults to true. */
  includeFeed?: boolean;
};

const CanonicalSEO: React.FC<CanonicalSEOProps> = ({
  slugs,
  locale,
  basePath = 'news',
  includeFeed = true,
}) => {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL?.replace(/\/$/, '') || ''; // Entfernt abschließendes "/"

  const currentSlug = slugs.find(item => item.locale === locale)?.slug;

  if (!currentSlug) {
    return null;
  }

  const constructUrl = (locale: string, slug: string) => {
    const path = locale === 'en' ? `${basePath}/${slug}` : `${locale}/${basePath}/${slug}`;
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

    return `${cleanBaseUrl}/${path}`;
  };

  return (
    <>
      <link rel="canonical" href={constructUrl(locale || 'en', currentSlug)} />
      {slugs.map(item => (
        <link
          key={item.locale}
          rel="alternate"
          href={constructUrl(item.locale, item.slug)}
          hrefLang={item.locale}
        />
      ))}
      {includeFeed && (
        <link
          rel="alternate"
          type="application/rss+xml"
          href={`${baseUrl}/sitemaps/${basePath}/feed/${locale}/feed.xml`}
        />
      )}

      {/* Default Language - x-default */}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={constructUrl(
          slugs.find(s => s.locale === 'en')?.slug ? 'en' : slugs[0].locale,
          slugs.find(s => s.locale === 'en')?.slug || slugs[0].slug
        )}
      />
    </>
  );
};

export default CanonicalSEO;
